import type { ConceptDef } from '../types';

export const matchQuantityToNumeral: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-quantity-to-numeral',
  label: 'Match Quantity-to-Numeral',
  category: 'Matching',
  description: 'See a group of dots; tap the matching numeral.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '••', answer: '2' },
      { say: '•••', answer: '3' },
      { say: '••••', answer: '4' },
      { say: '•••••', answer: '5' },
      { say: '••••••', answer: '6' },
    ],
  },
};
